/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { AiOutlineSearch } from 'react-icons/ai';

import {
  makeStyles,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@material-ui/core';
import Paper from '@material-ui/core/Paper';

import Collapse from '~/components/Collapse';

import ItemDetail, { Variable } from '../ItemDetail';
import ItemDetailSkeleton from '../ItemDetail/ItemDetailSkeleton';
import {
  Container,
  Content,
  Header,
  HeaderTitle,
  Wrapper,
  WrapperInput,
} from './styles';

interface DynamicDetailsProps {
  variables: Variable[] | undefined;
  columns: number;
  loading?: boolean;
}

const convertVariableIfBoolean = (value: string | boolean) => {
  if (value === true || value === false) return value ? 'Sim' : 'Não';
  return value;
};

const handleSearch = (searchText: string) => {
  if (searchText && searchText.length >= 3) {
    return searchText;
  }
  return '';
};

const hasOldVariable = (variables: Variable[] | undefined) => {
  return variables?.find((variable: any) => {
    if (variable?.oldVariables) {
      return true;
    }
    return false;
  });
};

const useStyles2 = makeStyles({
  table: {
    minWidth: 100,
  },
});

const DynamicDetails = ({
  variables,
  loading,
  columns,
}: DynamicDetailsProps) => {
  const [searchValue, setSearchValue] = useState('');

  const newVariables = variables?.filter(
    (variable) => variable.value && variable.value !== '',
  );

  const clientAnswers = newVariables?.filter(
    (newVariable: any) => newVariable.properties?.respostaCliente === '',
  );

  const afferoAnswers = newVariables?.filter(
    (newVariable: any) => newVariable.properties?.respostaAffero === '',
  );

  let afferoAnswersFormmated: any;

  if (afferoAnswers) {
    afferoAnswersFormmated = afferoAnswers[0]?.value.split(', ');
  }

  const classes = useStyles2();

  function createData(name: any, calories: any, fat: any) {
    return { name, calories, fat };
  }

  const rowsObject: any = [];

  if (clientAnswers && afferoAnswersFormmated) {
    clientAnswers.forEach((element: any) => {
      const existsInB = afferoAnswersFormmated.includes(element.label);
      rowsObject.push(
        createData(
          `${element.label}`,
          `${element.value}` === 'sim' ? 'Sim' : 'Não',
          existsInB ? 'Sim' : 'Não',
        ),
      );
    });
  }

  return (
    <Container>
      {hasOldVariable(variables) ? (
        <div>
          <Collapse label="Dados" defaultOpen={false}>
            <>
              <Wrapper style={{ margin: '16px 0px', justifyContent: 'end' }}>
                <AiOutlineSearch size={24} color="#B2B2B2" />
                <WrapperInput
                  value={searchValue}
                  placeholder="Buscar dado"
                  onChange={(e: any) => setSearchValue(e.target.value)}
                />
              </Wrapper>

              <Content numberOfColumns={columns}>
                {loading
                  ? Array.from(Array(6)).map((_, index) => (
                      // eslint-disable-next-line react/jsx-indent
                      <ItemDetailSkeleton key={`skeleton-${index}`} />
                    ))
                  : variables?.map(
                      (variable: any, index) =>
                        // eslint-disable-next-line react/jsx-indent
                        variable?.id !== 'dynamicTable' &&
                        variable?.oldVariables !== true && (
                          <ItemDetail
                            key={`item-detail-${index}`}
                            label={variable.label}
                            value={convertVariableIfBoolean(variable.value)}
                            highlighterProps={{
                              sanitize: handleSearch,
                              searchWords: [searchValue],
                            }}
                          />
                        ),
                    )}
              </Content>
            </>
          </Collapse>
        </div>
      ) : (
        <>
          <Header numberOfColumns={columns}>
            <HeaderTitle>Dados</HeaderTitle>
            <Wrapper>
              <AiOutlineSearch size={24} color="#B2B2B2" />
              <WrapperInput
                value={searchValue}
                placeholder="Buscar dado"
                onChange={(e: any) => setSearchValue(e.target.value)}
              />
            </Wrapper>
          </Header>
          <Content numberOfColumns={columns}>
            {loading
              ? Array.from(Array(6)).map((_, index) => (
                  // eslint-disable-next-line react/jsx-indent
                  <ItemDetailSkeleton key={`skeleton-${index}`} />
                ))
              : variables?.map(
                  (variable: any, index) =>
                    // eslint-disable-next-line react/jsx-indent
                    variable?.id !== 'dynamicTable' &&
                    variable?.oldVariables !== true && (
                      <ItemDetail
                        key={`item-detail-${index}`}
                        label={variable.label}
                        value={convertVariableIfBoolean(variable.value)}
                        highlighterProps={{
                          sanitize: handleSearch,
                          searchWords: [searchValue],
                        }}
                      />
                    ),
                )}
          </Content>
        </>
      )}
      {hasOldVariable(variables) && (
        <div style={{ marginTop: '48px' }}>
          <Collapse label="Dados Solicitação Acessória" defaultOpen={false}>
            <>
              <Wrapper style={{ margin: '16px 0px', justifyContent: 'end' }}>
                <AiOutlineSearch size={24} color="#B2B2B2" />
                <WrapperInput
                  value={searchValue}
                  placeholder="Buscar dado"
                  onChange={(e: any) => setSearchValue(e.target.value)}
                />
              </Wrapper>
              <Content numberOfColumns={columns}>
                {loading
                  ? Array.from(Array(6)).map((_, index) => (
                      // eslint-disable-next-line react/jsx-indent
                      <ItemDetailSkeleton key={`skeleton-${index}`} />
                    ))
                  : newVariables?.map(
                      (variable: any, index) =>
                        // eslint-disable-next-line react/jsx-indent
                        variable?.id !== 'dynamicTable' &&
                        variable?.oldVariables === true && (
                          <ItemDetail
                            key={`item-detail-${index}`}
                            label={variable.label}
                            value={convertVariableIfBoolean(variable.value)}
                            highlighterProps={{
                              sanitize: handleSearch,
                              searchWords: [searchValue],
                            }}
                          />
                        ),
                    )}
              </Content>
            </>
          </Collapse>
        </div>
      )}
      {clientAnswers && afferoAnswersFormmated && (
        <div style={{ marginTop: '48px' }}>
          <Collapse label="Checklist Final" defaultOpen>
            <TableContainer component={Paper} style={{ marginTop: '28px' }}>
              <Table
                className={classes.table}
                aria-label="custom pagination table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontSize: '13px', fontWeight: 'bold' }}>
                      Serviço
                    </TableCell>
                    <TableCell
                      style={{ fontSize: '13px', fontWeight: 'bold' }}
                      align="right"
                    >
                      Contratado
                    </TableCell>
                    <TableCell
                      style={{ fontSize: '13px', fontWeight: 'bold' }}
                      align="right"
                    >
                      Realizado
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rowsObject.map((row: any) => (
                    <TableRow key={row.name}>
                      <TableCell component="th" scope="row">
                        {row.name}
                      </TableCell>
                      <TableCell style={{ width: 100 }} align="right">
                        {row.calories}
                      </TableCell>
                      <TableCell style={{ width: 100 }} align="right">
                        {row.fat}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Collapse>
        </div>
      )}
    </Container>
  );
};
export default DynamicDetails;
